import { create } from 'zustand';

const useStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem('qtalk_user') || 'null'),
  token: localStorage.getItem('qtalk_token') || null,

  setUser: (user) => {
    localStorage.setItem('qtalk_user', JSON.stringify(user));
    set({ user });
  },
  setToken: (token) => {
    localStorage.setItem('qtalk_token', token);
    set({ token });
  },
  logout: () => {
    localStorage.removeItem('qtalk_token');
    localStorage.removeItem('qtalk_user');
    set({ user: null, token: null, conversations: [], activeConversation: null, messages: [] });
  },

  darkMode: localStorage.getItem('qtalk_theme') === 'dark',
  toggleDarkMode: () => {
    const newMode = !get().darkMode;
    localStorage.setItem('qtalk_theme', newMode ? 'dark' : 'light');
    set({ darkMode: newMode });
  },

  conversations: [],
  setConversations: (conversations) => {
    if (typeof conversations === 'function') {
      // Support functional updates like useState
      set(state => ({ conversations: conversations(state.conversations) }));
    } else {
      set({ conversations: Array.isArray(conversations) ? conversations : [] });
    }
  },
  removeConversation: (id) => set(state => ({
    conversations: state.conversations.filter(c => Number(c.id) !== Number(id))
  })),
  // ── GLOBAL UPLOADS
  uploads: [], // [{ id, fileName, progress, conversationId, convName, status:'uploading'|'done'|'error' }]
  socketConnected: true,
  setSocketConnected: (val) => set({ socketConnected: val }),
  addUpload: (upload) => set(state => ({ uploads: [...state.uploads, upload] })),
  updateUpload: (id, patch) => set(state => ({
    uploads: state.uploads.map(u => u.id === id ? { ...u, ...patch } : u)
  })),
  removeUpload: (id) => set(state => ({ uploads: state.uploads.filter(u => u.id !== id) })),
  clearDoneUploads: () => set(state => ({ uploads: state.uploads.filter(u => u.status === 'uploading') })),

  updateConversation: (updated) => set((state) => {
    const updatedList = state.conversations.map(c =>
      c.id === updated.id ? { ...c, ...updated } : c
    );
    // Re-sort: pinned conversations always on top, then by most recent (matches backend ORDER BY)
    updatedList.sort((a, b) => {
      if (a.is_pinned && !b.is_pinned) return -1;
      if (!a.is_pinned && b.is_pinned) return 1;
      const ta = a.last_message_time ? new Date(a.last_message_time).getTime() : 0;
      const tb = b.last_message_time ? new Date(b.last_message_time).getTime() : 0;
      return tb - ta;
    });
    return { conversations: updatedList };
  }),

  activeConversation: null,
  setActiveConversation: (conv) => set({ activeConversation: conv }),

  messages: [],
  setMessages: (messages) => set({ messages: Array.isArray(messages) ? messages : [] }),
  addMessage: (message) => set((state) => ({
    messages: [...(Array.isArray(state.messages) ? state.messages : []), message]
  })),

  onlineUsers: {},
  userStatuses: {}, // custom status per user id
  setUserOnline: (userId) => set((state) => ({
    onlineUsers: { ...state.onlineUsers, [userId]: true }
  })),
  setUserOffline: (userId) => set((state) => {
    const updated = { ...state.onlineUsers };
    delete updated[userId];
    return { onlineUsers: updated };
  }),
  setOnlineUsersBulk: (userIds) => set(() => {
    const map = {};
    userIds.forEach(id => { map[id] = true; });
    return { onlineUsers: map };
  }),

  setUserStatus: (userId, status) => set((state) => ({
    userStatuses: { ...state.userStatuses, [userId]: status }
  })),
  typingUsers: {},
  setTyping: (convId, userId, name) => set((state) => ({
    typingUsers: { ...state.typingUsers, [convId]: { userId, name } }
  })),
  clearTyping: (convId) => set((state) => {
    const updated = { ...state.typingUsers };
    delete updated[convId];
    return { typingUsers: updated };
  }),
}));

export default useStore;
